export const equityInvestInfoData = {}
